import Vue from 'vue'
import Router from 'vue-router'
/**医护管理**/
import doctorList from './nurseManage/AA_docotrManage'//医生管理
import deptList from './nurseManage/AB_deptManage'//科室管理
import recipeList from './nurseManage/AC_recipeManage'//处方管理
import visitList from './nurseManage/AD_visitManage'//处方管理
import doctorAssistantList from './nurseManage/AE_doctorAssistantManage'//医助管理
import studioList from './nurseManage/AF_studioManage'//医助管理
import statisticalReport from './nurseManage/AG_statisticalReport'//统计报表管理
import healthManagement from './nurseManage/AH_healthManagement'//健康管理系统


// import column from './nurseManage/column'//栏目管理
// import manuscript from './nurseManage/manuscript'//稿件管理
// import submit from './nurseManage/submit'//投稿管理
// import roleMent from './nurseManage/roleMent'//角色管理
// import specialMent from './nurseManage/specialMent'//专题管理
// import example from './nurseManage/example'//列子

/**用户管理**/
import userList from './userManage/AA_userManage'//微信用户管理
// import homePageManage from './userManage/AB_homePageManege'//banner配置
// import healthBulletin from './userManage/AD_healthBulletin' //每日健康管理
// import advertisingDelivery from './userManage/AE_advertisingDelivery' //每日健康管理
// import evaluationManagement from './userManage/AF_evaluationManagement' //评价管理
// import helpCenter from './userManage/AG_helpCenter' //帮助中心管理
import feedBack from './userManage/AH_feedBack' //意见反馈管理
import advertisingDelivery from './userManage/AE_advertisingDelivery' //广告投放管理
// import topicManage from './userManage/AC_topicManege'//专题管理
import inviteFriends from './userManage/inviteFriends' //邀请记录
import userFollowPage from './userManage/AI_userFollowPage' //用户关注
// import adsDispatch from "./userManage/adsDispatch";
/**系统设置**/
// import staffManage from './systemManage/AB_staffManage'
import userMent from './systemManage/userMent'//用户管理
import passwordManage from './systemManage/AC_passwordManage'
import operatorLog from './systemManage/AD_operatorLog'
import setService from './systemManage/AE_setService'
import appVersion from './systemManage/AG_appVersion'
import protocolPage from './systemManage/AH_protocolPage'
/**谷医糖**/
import bloodGlucose from './diabetesManage/AA_bloodGlucose'
import menstruationRecords from './diabetesManage/AA_menstruationRecords'
import sportsRecord from './diabetesManage/AA_sportsRecord'
import dietRecords from './diabetesManage/AA_dietRecords'
import weightRecords from './diabetesManage/AA_weightRecords'
import pressureRecords from './diabetesManage/AA_pressureRecords'
import niaoRecords from './diabetesManage/AA_niaoRecords'
import bloodFatRecords from './diabetesManage/AA_bloodFatRecords'
import medicalReport from './diabetesManage/AA_medicalReport'
import AA_OMORecords from './diabetesManage/AA_OMORecords'
import AA_pointManage from "./diabetesManage/AA_pointManage";
/**积分体系**/
import  pointsTask from './pointsManage/AA_pointsTask'
import  pointsMall from './pointsManage/AB_pointsMall'
import pointsManage from './pointsManage/AC_pointsManage'
import memberPoints from './pointsManage/AD_memberPoints'

/**商城模块**/
import memberManagement from './shoppMall/memberManagement'
import productManage from './shoppMall/productManage'
import homeManage  from './shoppMall/homeManage'
import indexManage  from './shoppMall/indexManage'
import dataReportManage  from './shoppMall/dataReportManage' // 数据报表
import marketingManage from './shoppMall/marketingManage' // 自营优惠券
import distributionManage from './shoppMall/distributionManage' // 分销管理
import selfcouponManage from './shoppMall/selfcouponManage' // 自营优惠券
import activityManage  from './shoppMall/activityManage' // 活动管理
import activityPageSet  from './shoppMall/activityPageSet' // 活动页配置
import aiChat  from './shoppMall/aiChat' // ai聊天历史记录页
import activityReview  from './shoppMall/activityReview' // 活动审核
import shortageManage  from './shoppMall/shortageManage' // 缺货登记
import popularscienceManage  from './shoppMall/popularscienceManage' // 科普管理
import storeManage  from './shoppMall/storeManage' // 科普管理
import coupon from './nurseManage/coupon' // 优惠券
import channelManage from './shoppMall/channelManage'
import examineManage from './shoppMall/examineManage'
import orderManage from './shoppMall/orderManage'
import orderManageself from './shoppMall/orderManageself'
import selfpromotionManage from './shoppMall/selfpromotionManage'
import groupBuyingOrderManagement from './shoppMall/groupBuyingOrderManagement'
import refundOrderManageOld from './shoppMall/refundOrderManageOld' // 退款订单管理
import platformManage from './shoppMall/platformManage'
import manufactorManage from './shoppMall/manufactorManage'
import brandManage from './shoppMall/brandManage'
import freightModule from './shoppMall/freightModule'
import pharmacistManage from './shoppMall/pharmacistManage' // 药师列表（药师管理）
// import pharmacistVerify from './shoppMall/pharmacistVerify' // 药品审核
import dataStatistics from './shoppMall/dataStatistics'
import otherSettings from './shoppMall/otherSettings'
import diversionEcommerce from './shoppMall/diversionEcommerce'
import goodsEvaluate from './shoppMall/goodsEvaluate'

/**问卷活动模块**/
import activityList from './questionnaireActivity/activityList'
import columnList from './questionnaireActivity/columnList'
import questionList from './questionnaireActivity/questionList'
import questionnaireUserList from './questionnaireActivity/questionnaireUserList'
import questionStatistics from './questionnaireActivity/questionStatistics'
import questionAccessingData from './questionnaireActivity/questionAccessingData'
import valleySideAccessData from './questionnaireActivity/valleySideAccessData'
import dataForm from './questionnaireActivity/dataForm'
import memberListData from './questionnaireActivity/memberListData'
import doctorListData from './questionnaireActivity/doctorListData'

/** Layout **/
import Layout from '@/views/layout/Layout'
import AA_beansCard from "./diabetesManage/AA_beansCard";


import dataReportForm from './dataReportForm/index'
Vue.use(Router);
var index = [{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  alwaysShow: false,
  children: [{
    path: '/dashboard',
    component: () => import('@/views/dashboard/index'),
    name: '首页',
    meta: {title: '首页', icon: 'dashboard', noCache: true}
  }]
},];

/**医护管理**/
const _asyncRouterMap = [].concat(
  doctorList,
  doctorAssistantList,
  studioList,
  deptList,
  recipeList,
  visitList,
  statisticalReport,
  healthManagement,//健康管理系统
  coupon,
  // refundOrderManage // 退款订单管理
  // roleMent,//
  // column,//栏目管理
  // submit,//投稿管理
  // manuscript,//稿件管理
  // specialMent,//专题管理
  // example,//列子
);
/**用户管理**/
const _asyncRouterMap1 = [].concat(
  userList,
  // homePageManage,
  // topicManage,
  // healthBulletin,
  advertisingDelivery,
  // evaluationManagement,
  // helpCenter,
  feedBack,
  userFollowPage,
  inviteFriends,
  // adsDispatch
);
/**系统设置**/
const _asyncRouterMap2 = [].concat(
  userMent,
  passwordManage,
  operatorLog,
  setService,
  appVersion,
  protocolPage,
);

/**谷医糖**/
const _asyncRouterMap3 = [].concat(
    menstruationRecords,
  bloodGlucose,
  sportsRecord,
  dietRecords,
  weightRecords,
  pressureRecords,
  niaoRecords,
  bloodFatRecords,
  medicalReport,
  AA_OMORecords,
  AA_beansCard,
  AA_pointManage
);

// 积分体系
const _asyncRouterMap4 = [].concat(
  pointsTask,
  pointsMall,
  pointsManage,
  memberPoints
);

// 商城模块
const _asyncRouterMap5 = [].concat(
  memberManagement,
  homeManage,
  indexManage,
  dataReportManage,
  marketingManage,
  selfcouponManage,
  selfpromotionManage,
  distributionManage,
  orderManageself,
  productManage,
  shortageManage,
  popularscienceManage,
  storeManage,
  activityManage,
  activityPageSet,
  aiChat,
  activityReview,
  coupon,
  examineManage,
  channelManage,
  orderManage,
  refundOrderManageOld, // 退款订单管理
  groupBuyingOrderManagement,
  platformManage,
  manufactorManage,
  brandManage,
  freightModule,
  pharmacistManage,
  // pharmacistVerify,
  dataStatistics,
  otherSettings,
  diversionEcommerce,
  goodsEvaluate
);

// 问卷活动模块
const _asyncRouterMap6 = [].concat(
  activityList,
  questionList,
  questionnaireUserList,
  columnList,
  questionStatistics,
  questionAccessingData,
  dataForm,
  valleySideAccessData,
  memberListData,
  doctorListData
);


export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/authredirect', component: () => import('@/views/login/authredirect'), hidden: true},
  {path: '/404', component: () => import('@/views/errorPage/404'), hidden: true},
  {path: '*', component: () => import('@/views/errorPage/404'), hidden: true},
  {path: '/401', component: () => import('@/views/errorPage/401'), hidden: true},
].concat(index, _asyncRouterMap, _asyncRouterMap1, _asyncRouterMap2, _asyncRouterMap3,_asyncRouterMap4,_asyncRouterMap5,_asyncRouterMap6,dataReportForm);
export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap,
})
export const asyncRouterMap = {
  indexRoute: index,
  nurserRoute: _asyncRouterMap,
  userRoute: _asyncRouterMap1,
  systemRoute: _asyncRouterMap2,
  diabetesRoute: _asyncRouterMap3,
  pointsRoute:_asyncRouterMap4,
  shopMallRoute: _asyncRouterMap5,
  questionnaireActivityRoute: _asyncRouterMap6,
  dataReportForm: dataReportForm,
};

// export const asyncRouterMap=index.concat(_asyncRouterMap);



// WEBPACK FOOTER //
// ./src/router/index.js